import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_69: FaireProductEntity = {
  token: "legacy_prod_abbott-69",
  type: "product",
  name: "Marine Kingdom Lined Notebook A5",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/40fbe20545af7b396d52919eab1328b71f2dedf644a6a2a483c406273a76bc4e.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
